// removed by extract-text-webpack-plugin
module.exports = {"this":"_2Jt5p6WdEF6mvFhdwBISTw","white":"EJY71hKwkzWYWdspIhw-q","left":"_2qbTD3DMPp_VakahLCEphC","right":"_2ON5LWgnfTuMyn2gHXVH56","orange":"_1jD9BgCRSBon5JJha5uwzR","danger":"_30ot7JLes6s22RcHBg-vxm","red":"_3SrAWEhVR5WLCCdwRk5GK4","center":"_207znj3EAVCFVBtXrIUGp","rightIcon":"ayvBrUP50cmzs2d_EygZg","leftIcon":"o0GfsqCWfzvqxVYc9xQ2b","leftText":"_1934j-Brug3SDkx35iNqYA"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/ui/Header.scss
// module id = 631
// module chunks = 12